import checkCountry from 'utils/checkCountry';
import request from 'utils/request';
import credentials from 'config/credentials';
import stadia from './stadia';
import stringifyPoint from './stringifyPoints';
import { TRAVELMODE_WALKING } from './constants';
import processOsrmData from './processOsrmData';
import gaTrack from './gaTrack';
import graphhopper from './graphhopper';
import { unserialize } from '../urlUtils';

function* directions(waypoints, travelMode) {
  const country = checkCountry(waypoints);
  const hash = unserialize(window.location.hash);
  if (hash.vehicle) {
    return yield graphhopper(waypoints, hash);
  }
  if (hash.valhalla || !country) {
    return yield stadia(waypoints, travelMode, hash);
  }
  const waypointString = waypoints.map(stringifyPoint).join(';');
  const mode = travelMode === TRAVELMODE_WALKING ? 'walking' : 'cycling';
  const countryPostfix = country === 'be' ? 'be' : '';
  const options = ['annotations=distance', 'overview=full'];
  let data;
  try {
    const url = `https://routing2.runnermaps.nl/route/v1/${mode}${countryPostfix}/${waypointString}?${options.join(
      '&',
    )}`;
    data = yield request(url, {}, gaTrack);
  } catch (err) {
    options.push(credentials.mapbox);
    const url = `https://api.mapbox.com/directions/v5/mapbox/${mode}/${waypointString}?${options.join(
      '&',
    )}`;
    data = yield request(url, {}, gaTrack);
  }
  return processOsrmData(data);
}

export default directions;
